module.exports = __webpack_public_path__ + "img/Telavox-1024x410.0ece8216.png";